import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    standalone: true,
    imports: []
})
export class MainMenuComponent implements OnDestroy {
    isMenuOpen: boolean = false;
    private routerSubscription: Subscription;

    constructor(private router: Router) {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.isMenuOpen = false;
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
    
    toggleMenu(event: Event): void {
        event.preventDefault();
        this.isMenuOpen = !this.isMenuOpen;
    }
}
